// import { useRef } from 'react';
// import React from 'react'
// import '../../../Style/online-train/form.css'
// import { useState } from 'react'
// // import Downloads from '../Download/NewDown';
// // import Answer from '../Download/Answer';
// import DownloadAddWork from '../Download/DownloadAddWork'
// const random = (min, max) => {
//   return (Math.floor(Math.random() * (max - min + 1)) + min);
// }
// const GenAdd = () => {

//   const getswitch = (digit1) => {
//     switch (digit1) {
//       case '1':
//         return random(1, 9)
//         break;
//       case '2':
//         return random(10, 99)
//         break;
//       case '3':
//         return random(100, 999)
//         break;
//       case '4':
//         return random(1000, 9999)
//         break;
//       default:
//         break;
//     }
//   }
//   const [digit1, setdigit1] = React.useState();
//   const [row, setrow] = React.useState();
//   const [ques, setques] = React.useState();
//   const [file, setfile] = React.useState();
//   const [sub, setsub] = React.useState(0);
//   const [zig, setzig] = React.useState(0);
//   const [isans, setisans] = React.useState(1);
//   const [btn, setbtn] = React.useState(0);
//   const [lessthan, setlessthan] = React.useState(0);
//   // const mat = []
//   const [mat, setmat] = useState([])
//   const [refrsh, setrefrsh] = useState(0)
//   const [showPopup, setShowPopup] = useState(false);
//   let lowval = 1;

//   const refpdf = useRef();

//   const getmat = (ques, row) => {

//   }
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setShowPopup(true);
//   };



//   function Xbtn(event) {
//     setbtn(0)
//     // window.location.reload()    
//   }

//   function cal(event) {
//     event.preventDefault();
//     if (refrsh) {
//       window.location.reload()
//     }
//     // if (!sub && !zig) {
//     //   getmat(ques, row)
//     // }

//     let min;
//     let max;

//     switch (digit1) {
//       case '1':
//         min = 1
//         max = 9
//         break;
//       case '2':
//         min = 10
//         max = 99
//         break;
//       case '3':
//         min = 100
//         max = 999
//         break;
//       case '4':
//         min = 1000
//         max = 9999
//         break;
//       default:
//         break;
//     }

//     if (!zig && !sub && !lessthan) {
//       let temp = []
//       let ele;
//       for (let j = 0; j < ques; j++) {
//         for (let i = 0; i < row; i++) {
//           ele = getswitch(digit1)
//           temp.push(ele)
//         }
//         mat.push(temp)
//         temp = []
//       }
//     }

//     if ((!zig && !sub && lessthan) || (zig && !sub && lessthan)) {
//       if (row > 4 || digit1 > 2) {
//         alert("soory! In level-2 the row shloud be lessthan 4 and digit must be lessthan or equal  2")
//       } else {
//         if (zig && lessthan && !sub) {
//           min = 1;
//         }
//         for (let i = 0; i < ques; i++) {
//           let temp = [];
//           let tem1 = 0;
//           let tem2 = 0;
//           let tem3 = 0;
//           let tem4 = 0;
//           do {

//             if (row == 2) {
//               tem1 = random(min, max)
//               tem2 = random(min, max)
//             } else if (row == 3) {
//               tem1 = random(min, max)
//               tem2 = random(min, max)
//               tem3 = random(min, max)
//             } else if (row == 4) {
//               tem1 = random(min, max)
//               tem2 = random(min, max)
//               tem3 = random(min, max)
//               tem4 = random(min, max)
//             }

//           } while ((tem1 + tem2 + tem3 + tem4) >= 100)

//           if (row == 2) {
//             temp.push(tem1)
//             temp.push(tem2)
//             // temp.push(tem3)
//           } else if (row == 3) {
//             temp.push(tem1)
//             temp.push(tem2)
//             temp.push(tem3)
//           } else if (row == 4) {
//             temp.push(tem1)
//             temp.push(tem2)
//             temp.push(tem3)
//             temp.push(tem4)
//           }

//           mat.push(temp)
//         }

//       }
//     }

//     if (zig && !sub && !lessthan) {
//       console.log("ss3")

//       let temp = []
//       let ele;
//       for (let j = 0; j < ques; j++) {
//         for (let i = 0; i < row; i++) {
//           ele = random(1, max)
//           if (random(1, 9) == 2 || random(1, 9) == 6) {
//             ele = random(1, 50)
//           }
//           temp.push(ele)
//         }
//         mat.push(temp)
//         temp = []
//       }
//     }




//     if (!zig && sub && !lessthan) {
//       for (let i = 0; i < ques; i++) {
//         let temo = [];
//         let total = 0;
//         for (let j = 0; j < row; j++) {
//           let ele = 0;
//           do {
//             if (total == 0) {
//               ele = random(min, max)
//             } else {
//               // console.log(total)
//               // ele = random(-max, max);
//               if (random(2, 3) == 3) {
//                 ele = random(-min, -max)
//               } else {
//                 ele = random(min, max)
//               }
//               if (Math.sign(ele + total) == -1) {
//                 while (Math.sign(ele + total) <= -1) {
//                   ele = random(min, max)
//                 }
//               }
//             }
//           } while ((temo.includes(Math.abs(ele)) && Math.sign(ele) == -1) || ele == 0)
//           total = ele + total
//           temo.push(ele)
//         }
//         mat.push(temo)
//         temo = []
//       }
//     }


//     if (!zig && sub && !lessthan) {

//       for (let i = 0; i < ques; i++) {
//         let temp = [];
//         let rowSum = 0;
//         let cumulativeSum = 0; // Tracks cumulative sum to ensure it doesn't go negative

//         for (let j = 0; j < row; j++) {
//           let ele;

//           do {
//             // Generate random value between -max and max
//             ele = Math.floor(Math.random() * (2 * max + 1)) - max;
//           } while (
//             rowSum + ele > 100 ||                // Ensure total row sum does not exceed 100
//             rowSum + ele < 0 ||                  // Ensure total row sum is not negative
//             cumulativeSum + ele < 0              // Ensure cumulative sum is non-negative at each step
//           );

//           temp.push(ele);
//           rowSum += ele;
//           cumulativeSum += ele;
//         }

//         mat.push(temp);
//       }

//     }



//     if (sub && zig && !lessthan) {
//       for (let i = 0; i < ques; i++) {
//         let temo = [];
//         let total = 0;
//         for (let j = 0; j < row; j++) {
//           let ele = 0;
//           if (total == 0) {
//             ele = random(min, max)
//           } else {
//             ele = random(-total, total);
//           }
//           total = ele + total
//           temo.push(ele)
//         }
//         mat.push(temo)
//         temo = []
//       }

//     }



//     if ((!zig && sub && lessthan) || (zig && sub && lessthan)) {
//       // if(zig && sub && lessthan){
//       //   threshold = 0
//       // }
//       for (let i = 0; i < ques; i++) {
//         let temp = [];
//         let sum = 0;
//         let cumulativeSum = 0;

//         for (let j = 0; j < row; j++) {
//           let num;
//           do {
//             num = random(-max, max); // Can be negative or positive
//           } while (sum + num >= 100 || (cumulativeSum + num < 0) || num == 0);

//           temp.push(num);
//           sum += num;
//           cumulativeSum += num;
//         }

//         mat.push(temp);
//       }
//     }

//     if (mat.length != 0) {
//       setbtn(1)
//     }

//   }

//   let props = {
//     ques: ques,
//     row: row,
//     mat: mat,
//     file: file,
//     isans: isans

//   }


//   const targetRef = useRef();

//   return (
//     <div className='bg'>
//       <div className='main'>
//         <form onSubmit={cal} className='main-form'>
//           <div className='form-back-img'></div>
//           <h2 className='form-name'>Add<span className='underline'>ition/Subract</span>ion</h2>
//           <label htmlFor="digit">Number of Digit</label>
//           <input type="number" max="4" className='box' name="name" id="digit" placeholder="2" onChange={(e) => { setdigit1(e.target.value) }} required />

//           <label htmlFor="row">Number of Rows</label>
//           <input type="number" name="email" className='box' id="row" placeholder="3" required onChange={(e) => { setrow(e.target.value) }} />
//           <div className='check' >
//             <label htmlFor="sub">Include Subraction  </label>
//             <div class="checkbox-wrapper-2">
//               <input type="checkbox" name="reference" className="sc-gJwTLC ikxBAC" id="sub" onClick={() => { return sub ? setsub(false) : setsub(true) }} />
//             </div>
//           </div>
//           <div className='check'>
//             <label htmlFor="zig">Zig-zag  </label>
//             {/* <span className='arrow'>&#8594;</span> */}
//             <div class="checkbox-wrapper-2">
//               {/* <input type="checkbox" class="sc-gJwTLC ikxBAC" /> */}
//               <input type="checkbox" className="sc-gJwTLC ikxBAC" name="zig-zag" id="zig-zag" onClick={() => { return zig ? setzig(false) : setzig(true) }} />

//             </div>
//           </div>
//           <div className='check'>
//             <label htmlFor="lessthan100">Level 2  </label>
//             <div class="checkbox-wrapper-2">
//               <input type="checkbox" className="sc-gJwTLC ikxBAC" name="lessthan" id="lessthan" onClick={() => { return lessthan ? setlessthan(false) : setlessthan(true) }} />
//             </div>
//           </div>
//           <label htmlFor='ques'>No Of Questions</label>
//           <input type="number" name="ques" id="ques" className="box" placeholder="10" required onChange={(e) => { setques(e.target.value) }} />
//           <label htmlFor='ques'>File name</label>
//           <input type="text" name="file" id="file" className="box" placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />

//           <div className='submit'>
//             <input type="submit" className='bt-purple' id='reset' value="Finish" />
//             <input type="reset" className='bt-purple' id='reset' value="Refresh" onClick={() => { window.location.reload() }} />
//           </div>
//         </form>
//       </div>
//       {/* <div className={btn ? "pop-bg" : "no-pop-bg"}></div> */}
//       {/* <div className={btn ? "pop-up" : "no-pop-up"} >
//         <button className='X-btn' onClick={() => { setbtn(0) }}>X</button>
//         <div className='pop-up-bg'>
//           <DownloadAddWork {...{ row, mat, ques, file }} />
//           <DownloadAddWork {...{ row, mat, ques, file, isans }} />
//         </div>
//       </div> */}

//       <div className={btn ? "popUp-download" : "hide-popUp-download"}>
//         <button className='X-btn' onClick={() => { Xbtn() }}>X</button>
//         <div className='download-ques-btn'>
//           <DownloadAddWork {...{ row, mat, ques, file }} />
//           <DownloadAddWork {...{ row, mat, ques, file, isans }} />
//         </div>
//       </div>

//     </div>
//   )
// }
// export default GenAdd


import React, { useState } from 'react'
import '../../../Style/online-train/form.css'
import DownloadAddWork from '../Download/DownloadAddWork'

const random = (min, max) => {
  return (Math.floor(Math.random() * (max - min + 1)) + min);
}

// Single source of truth for digit -> number-range mapping.
// (This used to be defined twice: once in getswitch(), once again inline in cal().)
const DIGIT_RANGES = {
  '1': [1, 9],
  '2': [10, 99],
  '3': [100, 999],
  '4': [1000, 9999],
};
const getDigitRange = (digit) => DIGIT_RANGES[digit] || DIGIT_RANGES['2'];

const GenAdd = () => {
  const [digit1, setdigit1] = useState();
  const [row, setrow] = useState();
  const [ques, setques] = useState();
  const [file, setfile] = useState();
  const [sub, setsub] = useState(0);
  const [zig, setzig] = useState(0);
  const [isans, setisans] = useState(1);
  const [btn, setbtn] = useState(0);
  const [lessthan, setlessthan] = useState(0);
  const [mat, setmat] = useState([]);

  const getswitch = (digit) => {
    const [min, max] = getDigitRange(digit);
    return random(min, max);
  };

  function Xbtn() {
    setbtn(0);
  }

  function cal(event) {
    event.preventDefault();

    const [min, max] = getDigitRange(digit1);

    // Build into a fresh local array instead of mutating the previous
    // render's `mat` state directly. That old approach meant rows kept
    // accumulating every time "Finish" was clicked without a page reload.
    const generated = [];

    if (!zig && !sub && !lessthan) {
      for (let j = 0; j < ques; j++) {
        const rowArr = [];
        for (let i = 0; i < row; i++) {
          rowArr.push(getswitch(digit1));
        }
        generated.push(rowArr);
      }
    }

    if ((!zig && !sub && lessthan) || (zig && !sub && lessthan)) {
      if (row > 4 || digit1 > 2) {
        alert("Sorry! In level-2 the row should be less than 4 and digit must be less than or equal to 2");
      } else {
        const levelMin = (zig && lessthan && !sub) ? 1 : min;
        for (let i = 0; i < ques; i++) {
          let vals;
          do {
            vals = Array.from({ length: row }, () => random(levelMin, max));
          } while (vals.reduce((a, b) => a + b, 0) >= 100);
          generated.push(vals);
        }
      }
    }

    if (zig && !sub && !lessthan) {
      for (let j = 0; j < ques; j++) {
        const rowArr = [];
        for (let i = 0; i < row; i++) {
          let ele = random(1, max);
          if (random(1, 9) === 2 || random(1, 9) === 6) {
            ele = random(1, 50);
          }
          rowArr.push(ele);
        }
        generated.push(rowArr);
      }
    }

    // NOTE: previously this exact condition (`!zig && sub && !lessthan`) had
    // TWO separate implementations back to back, so every question was
    // generated twice (doubling rows) and the first copy also called the
    // broken `random(-min, -max)` (invalid since -min > -max for this
    // random() helper). Only one version remains below, and it's been
    // rewritten so that:
    //   1. Zig-zag is OFF here, so EVERY number (regardless of sign) must
    //      stay a proper n-digit number -- its magnitude is always drawn
    //      from [min, max], never anything smaller. Previously it drew from
    //      [-max, max], which could produce a 1- or 2-digit result even
    //      when the user asked for 3 digits.
    //   2. A number can never come out as exactly 0.
    if (!zig && sub && !lessthan) {
      for (let i = 0; i < ques; i++) {
        const rowArr = [];
        let runningTotal = 0;

        for (let j = 0; j < row; j++) {
          let ele;
          if (j === 0) {
            // first number is always positive
            ele = random(min, max);
          } else {
            do {
              const magnitude = random(min, max); // always the chosen digit-count
              const sign = random(0, 1) === 0 ? -1 : 1;
              ele = sign * magnitude;
            } while (runningTotal + ele < 0); // keep the running total non-negative

          }
          runningTotal += ele;
          rowArr.push(ele);
        }

        generated.push(rowArr);
      }
    }

    if (sub && zig && !lessthan) {
      for (let i = 0; i < ques; i++) {
        const rowArr = [];
        let total = 0;
        for (let j = 0; j < row; j++) {
          let ele;
          if (total === 0) {
            ele = random(min, max);
          } else {
            do {
              ele = random(-total, total);
            } while (ele === 0); // never let a subtraction step land on exactly 0
          }
          total += ele;
          rowArr.push(ele);
        }
        generated.push(rowArr);
      }
    }

    if ((!zig && sub && lessthan) || (zig && sub && lessthan)) {
      for (let i = 0; i < ques; i++) {
        const rowArr = [];
        let sum = 0;
        let cumulativeSum = 0;

        for (let j = 0; j < row; j++) {
          let num;
          do {
            num = random(-max, max);
          } while (sum + num >= 100 || (cumulativeSum + num < 0) || num === 0);

          rowArr.push(num);
          sum += num;
          cumulativeSum += num;
        }

        generated.push(rowArr);
      }
    }

    setmat(generated);
    if (generated.length !== 0) {
      setbtn(1);
    }
  }

  return (
    <div className='bg'>
      <div className='main'>
        <form onSubmit={cal} className='main-form'>
          <div className='form-back-img'></div>
          <h2 className='form-name'>Add<span className='underline'>ition/Subract</span>ion</h2>
          <label htmlFor="digit">Number of Digit</label>
          <input type="number" max="4" className='box' name="name" id="digit" placeholder="2" onChange={(e) => { setdigit1(e.target.value) }} required />

          <label htmlFor="row">Number of Rows</label>
          <input type="number" name="email" className='box' id="row" placeholder="3" required onChange={(e) => { setrow(e.target.value) }} />
          <div className='check' >
            <label htmlFor="sub">Include Subraction  </label>
            <div className="checkbox-wrapper-2">
              <input type="checkbox" name="reference" className="sc-gJwTLC ikxBAC" id="sub" onClick={() => { return sub ? setsub(false) : setsub(true) }} />
            </div>
          </div>
          <div className='check'>
            <label htmlFor="zig">Zig-zag  </label>
            <div className="checkbox-wrapper-2">
              <input type="checkbox" className="sc-gJwTLC ikxBAC" name="zig-zag" id="zig-zag" onClick={() => { return zig ? setzig(false) : setzig(true) }} />
            </div>
          </div>
          <div className='check'>
            <label htmlFor="lessthan100">Within 100  </label>
            <div className="checkbox-wrapper-2">
              <input type="checkbox" className="sc-gJwTLC ikxBAC" name="lessthan" id="lessthan" onClick={() => { return lessthan ? setlessthan(false) : setlessthan(true) }} />
            </div>
          </div>
          <label htmlFor='ques'>No Of Questions</label>
          <input type="number" name="ques" id="ques" className="box" placeholder="10" required onChange={(e) => { setques(e.target.value) }} />
          <label htmlFor='ques'>File name</label>
          <input type="text" name="file" id="file" className="box" placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />

          <div className='submit'>
            <input type="submit" className='bt-purple' id='reset' value="Finish" />
            <input type="reset" className='bt-purple' id='reset' value="Refresh" onClick={() => { window.location.reload() }} />
          </div>
        </form>
      </div>

      <div className={btn ? "popUp-download" : "hide-popUp-download"}>
        <button className='X-btn' onClick={() => { Xbtn() }}>X</button>
        <div className='download-ques-btn'>
          <DownloadAddWork {...{ row, mat, ques, file }} />
          <DownloadAddWork {...{ row, mat, ques, file, isans }} />
        </div>
      </div>
    </div>
  )
}
export default GenAdd